import {
  OVERVIEW_TRACKER_SET_FILTER,
  CALENDAR_SET_SUBMIT_CLICKED,
  CALENDAR_V2_MONTH_REQUESTED,
  CALENDAR_V2_MONTH_RECEIVED,
  CALENDAR_V2_MONTH_FAILED,
  CALENDAR_V2_DAY_REQUESTED,
  CALENDAR_V2_DAY_RECEIVED,
  CALENDAR_V2_DAY_FAILED
} from "../actions/dualcalendar.actions";
import { INITIALIZE_STORE } from "../actions/manager.actions";
import dayjs from "dayjs";

const initialV2CalendarState = {
  month: null,
  monthLoading: false,
  pendingMonth: null,
  day: null,
  dayLoading: false,
  pendingDay: null,
};

const initialState = {
  // Team baseline averages, one map per calendar, written from each /calendar/month
  // response. Common/PlanTable reads them to colour its Total row.
  colors_1: {},
  colors_2: {},
  submitClicked: false,
  // Keyed by calendarId so both dual calendars can run v2 independently.
  v2: {
    1: initialV2CalendarState,
    2: initialV2CalendarState,
  },
  filters: {
    playersFilter : [],
    positionsFilter: [],
    playerGroupsFilter: [],
    selectedMonth: dayjs(),
    playerStatusesFilter: [],
    sessionsFilter: [],
    flagTypesFilter: []
  },
};

const v2Slice = (state, calendarId) => state.v2[calendarId] ?? initialV2CalendarState;

const mergeV2 = (state, calendarId, patch) => ({
  ...state,
  v2: {
    ...state.v2,
    [calendarId]: { ...v2Slice(state, calendarId), ...patch },
  },
});

// A response is stale once a newer month/day has been requested for the same
// calendar, and must not overwrite what the user is now looking at.
const isStaleV2 = (state, action, pendingField) =>
  v2Slice(state, action.calendarId)[pendingField] !== action.requestKey;

export const dualCalendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case CALENDAR_SET_SUBMIT_CLICKED:
      return {
        ...state,
        submitClicked: action.payload,
      };
    case OVERVIEW_TRACKER_SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.data
        }
      };
    case CALENDAR_V2_MONTH_REQUESTED:
      return mergeV2(state, action.calendarId, { monthLoading: true, pendingMonth: action.requestKey });
    case CALENDAR_V2_MONTH_RECEIVED:
      return isStaleV2(state, action, "pendingMonth")
        ? state
        : {
            ...mergeV2(state, action.calendarId, { month: action.payload, monthLoading: false, pendingMonth: null }),
            [`colors_${action.calendarId}`]: action.colors,
          };
    case CALENDAR_V2_MONTH_FAILED:
      return isStaleV2(state, action, "pendingMonth")
        ? state
        : mergeV2(state, action.calendarId, { monthLoading: false, pendingMonth: null });
    case CALENDAR_V2_DAY_REQUESTED:
      return mergeV2(state, action.calendarId, { day: null, dayLoading: true, pendingDay: action.requestKey });
    case CALENDAR_V2_DAY_RECEIVED:
      return isStaleV2(state, action, "pendingDay")
        ? state
        : mergeV2(state, action.calendarId, { day: action.payload, dayLoading: false, pendingDay: null });
    case CALENDAR_V2_DAY_FAILED:
      return isStaleV2(state, action, "pendingDay")
        ? state
        : mergeV2(state, action.calendarId, { dayLoading: false, pendingDay: null });
    case INITIALIZE_STORE:
      return initialState;
    default:
      return state;
  }
};
